// components/common/ConfirmDialog.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ConfirmDialog = ({
  show,
  onCancel,
  onConfirm,
  title = "Confirm Changes",
  message = "Are you sure you want to save these changes?",
  confirmText = "Save",
  cancelText = "Cancel",
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-0">{t(message)}</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="main_btn outline" onClick={onCancel} disabled={isLoading}>
          {t(cancelText)}
        </button>
        <button className="main_btn" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? t("Saving...") : t(confirmText)}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;